var map = {
	"./comunebg/colors/theme.scss": "e18b",
	"./dark/colors/theme.scss": "98b5",
	"./default/colors/theme.scss": "d306",
	"./emergency/colors/theme.scss": "6e9a",
	"./hoval/colors/theme.scss": "27d4",
	"./sorint/colors/theme.scss": "50f9",
	"./vimm/colors/theme.scss": "bf7c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d486";